import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Dialog, DialogContent, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { BaseButton } from 'components/BaseButton';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => createStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    padding: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(0, 3, 3),
  },
}));

type SendConfirmDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/** Warns before the assistant's open conversation is cleared to make room for a new import. */
export const SendConfirmDialog = ({ open, onConfirm, onCancel }: SendConfirmDialogProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogContent className={classes.content}>
        <Typography variant="h6">{t('imports:send.clearTitle')}</Typography>
        <Typography variant="body2">{t('imports:send.clearBody')}</Typography>
      </DialogContent>
      <div className={classes.actions}>
        <BaseButton
          text={t('common:cancel')}
          icon={faTimes}
          buttonVariant="outlined"
          buttonColor="inherit"
          textColor={theme.palette.text.primary}
          height={theme.spacing(5)}
          onClick={onCancel}
        />
        <BaseButton
          text={t('imports:send.clearConfirm')}
          icon={faCheck}
          height={theme.spacing(5)}
          onClick={onConfirm}
        />
      </div>
    </Dialog>
  );
};
